export const Units = {
  1: 'l',
  2: 'g',
  5: 'lfm',
  6: 'kg',
  8: 'Paket(e)',
  9: 'Stck.',
  10: 'ml',
  11: 'Stück',
} as const;
